var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTranslate = function SvgTranslate(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-24": 18,
    viewBox: "0 0 17.5 16.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M.75 1.75h11m-5.5-1v1m1 9.5c-1.54-1.594-2.637-2.959-3.5-5m5.25 7h6.5m-7.75 2.5 4.5-9 4.5 9m-6.749-14C9.033 7.52 5.82 10.73.75 13.25"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTranslate);
export default ForwardRef;